import React, { Fragment, useEffect, useReducer, useState } from "react";
import { toastMessage } from "../../../helper";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { STEPS } from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import ExternalAuditSummary from "./ExternalAuditSummary";
import AuditUploadCertificate from "./AuditUploadCertificate";
import { updateExternalAuditService } from "../../../services/verificationService";
import { success } from "../../../constants/colorConstants";
import AuditSubmitConfirmationDialog from "./AuditSubmitConfirmationDialog";

const TargetHome = () => {
  const [logoutAction]: any = useOutletContext();
  const [step, setStep] = useState(STEPS.EMISSION_AUDIT_SUMMARY);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [summaryFormData, setSummaryFormData] = useState<any>({
    attachments: [],
    comments: "",
  });
  const [
    auditSubmitConfirmationDialogOpen,
    setAuditSubmitConfirmationDialogOpen,
  ] = useState(false);
  const [auditSubmitSuccess, setAuditSubmitSuccess] = useState(false);

  const handleSummarySubmit = () => {
    let auditRequestId =
      localStorage.getItem("auditRequestId") &&
      JSON.parse(localStorage.getItem("auditRequestId") || "");

    var payload = {
      ...summaryFormData,
      status: "Completed",
      id: auditRequestId,
    };
    if (summaryFormData.attachments?.length) {
      payload.attachments = { files: summaryFormData.attachments };
    }
    updateExternalAuditService(payload)
      .then((res: any) => {
        setAuditSubmitSuccess(true);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const handleConfirmDialogClose = () => {
    setAuditSubmitSuccess(false);
    setAuditSubmitConfirmationDialogOpen(false);
    if (auditSubmitSuccess) {
      // toastMessage("Summary submitted successfully", "success");
      // navigate("/log/Emissions");
      logoutAction();
    }
  };

  const openConfirmationDialog = () => {
    setAuditSubmitConfirmationDialogOpen(true);
  };

  return (
    <Fragment>
      <div className="pw-emission-home w-full  flex flex-row grow">
        <div className="pw-creation-side-bar">
          <div
            className={`pw-org-side-elem ${
              step === STEPS.EMISSION_AUDIT_SUMMARY
                ? "pw-org-active"
                : "pw-org-inactive"
            }`}
            onClick={() => {
              setStep(STEPS.EMISSION_AUDIT_SUMMARY);
            }}
          >
            {t("Emission Summary")}
          </div>
          <div
            className={`pw-org-side-elem ${
              step === STEPS.UPLOAD_CERTIFICATE
                ? "pw-org-active"
                : "pw-org-inactive"
            }`}
            onClick={() => {
              setStep(STEPS.UPLOAD_CERTIFICATE);
            }}
          >
            {t("Upload Certificate")}
          </div>
        </div>
        <div className="overflow-y-auto pw-emission-home-main">
          <div
            className="h-full"
            style={{
              display: step === STEPS.EMISSION_AUDIT_SUMMARY ? "block" : "none",
            }}
          >
            <ExternalAuditSummary setStep={setStep} />
          </div>
          {step === STEPS.UPLOAD_CERTIFICATE ? (
            <div className="h-full">
              <AuditUploadCertificate
                setStep={setStep}
                setSummaryFormData={setSummaryFormData}
                summaryFormData={summaryFormData}
                handleSummarySubmit={openConfirmationDialog}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {auditSubmitConfirmationDialogOpen && (
        <AuditSubmitConfirmationDialog
          open={auditSubmitConfirmationDialogOpen}
          onClose={handleConfirmDialogClose}
          onConfirm={handleSummarySubmit}
          showSuccess={auditSubmitSuccess}
        />
      )}
    </Fragment>
  );
};

export default TargetHome;
